import { DetailFieldList } from "@/shared/components";
import { DetailSection } from "../../../detail-section";
import type { DimensoesPrincipaisSectionViewModel } from "./types-dimensoes-principais-section";

export function DimensoesPrincipaisSectionView({
  id,
  title,
  testId,
  fieldsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  fields,
}: DimensoesPrincipaisSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailFieldList testId={fieldsTestId} fields={fields} />
    </DetailSection>
  );
}
